/**
 *  Copyright (c) 2021-present The TVM Engineering Authors.
 *
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() => ({
	root: {
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		background: '#DDE5E'
	},
	circularProgress: {
		marginTop: '15%',
		marginBottom: '15%'
	}
}));

const LoadingScreen = React.memo(() => {
	const classes = useStyles();
	// const [loading, setLoading] = React.useState(false);
	const timerRef = React.useRef();
	
	React.useEffect(
		() => () => {
			clearTimeout(timerRef.current);
		},
		[],
	);
	
	return (
		<div className={classes.root}>
			<LinearProgress color="primary"/>
			<LinearProgress color="primary"/>
			
			<CircularProgress
				className={classes.circularProgress}
				color="primary"
				disableShrink
				size={40}
				thickness={5}
			/>
		</div>
	);
});

export default LoadingScreen;
